// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";

import type { $Site } from "flow/types";
type $Props = {
  classes: Object,
  footerPod: string,
  site: $Site,
};

const CustomerDisclaimer = ({ classes, footerPod, site }: $Props) => {
  if (!site) {
    return null;
  }
  const { siteConfig } = site;
  if (
    siteConfig &&
    siteConfig.footer &&
    siteConfig.footer.customDisclaimerText
  ) {
    return (
      <div
        className={classNames({
          [classes.root]: true,
          [classes.threeCols]: footerPod === "threeCols",
          [classes.twoLevel]: footerPod === "twoToneAndTwoLevelFooter",
        })}
      >
        <div className={classes.disclaimer}>
          <div
            className={classNames(
              "ref__custom-footer-compliance-text",
              classes.complianceText
            )}
            dangerouslySetInnerHTML={{
              __html: siteConfig.footer.customDisclaimerText,
            }}
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

const styles = (theme) => {
  return {
    root: {
      display: "block",
      position: "relative",
      width: "100%",
      padding: "20px 0",
      color: (props) =>
        props.footerPod === "threeCols"
          ? theme.colors.primaryFontColor
          : "#fff",
    },
    threeCols: {
      backgroundColor: theme.colors.primary["500"],
    },
    twoLevel: {
      backgroundColor: theme.colors.gray["900"],
    },
    disclaimer: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    complianceText: {
      width: "100%",
      maxWidth: "900px",
      padding: "20px 15px 0",
      textAlign: "center",
    },
  };
};

export default withGlobalContext(withStyles(styles)(CustomerDisclaimer));
